<template>
    <header class="sticky top-0 z-20 flex h-16 items-center gap-2 border-b border-surface-200 bg-surface-0/80 px-3 backdrop-blur sm:px-5 dark:border-surface-800 dark:bg-surface-900/80">
        <button
            v-tooltip.bottom="$t('nav.open_menu')"
            :aria-label="$t('nav.open_menu')"
            class="rounded-lg p-2 text-surface-600 transition-colors hover:bg-surface-100 lg:hidden dark:text-surface-300 dark:hover:bg-surface-800"
            @click="emit('toggle-mobile')"
        >
            <i class="pi pi-bars text-lg" />
        </button>

        <span class="truncate text-sm font-medium text-surface-500">{{ $t('app.console') }}</span>

        <div class="flex-1" />

        <button
            v-tooltip.bottom="$t('general.theme')"
            :aria-label="$t('general.theme')"
            class="rounded-lg p-2 text-surface-600 transition-colors hover:bg-surface-100 dark:text-surface-300 dark:hover:bg-surface-800"
            @click="toggleDark"
        >
            <i class="pi text-lg" :class="isDark ? 'pi-sun' : 'pi-moon'" />
        </button>

        <button
            :aria-label="$t('nav.account')"
            class="flex items-center gap-2 rounded-lg p-1 pr-2 transition-colors hover:bg-surface-100 dark:hover:bg-surface-800"
            @click="menu?.toggle($event)"
        >
            <span class="flex size-8 items-center justify-center rounded-full bg-primary-600 text-sm font-medium text-white">
                <i class="pi pi-user text-sm" />
            </span>
            <i class="pi pi-angle-down hidden text-xs text-surface-400 sm:block" />
        </button>

        <Menu ref="menu" :model="menuItems" popup>
            <template #start>
                <div class="border-b border-surface-200 px-3 py-2 dark:border-surface-800">
                    <div class="truncate text-sm font-medium text-surface-900 dark:text-surface-0">{{ $t('app.name') }}</div>
                    <div class="truncate text-xs text-surface-500">{{ $t('nav.account') }}</div>
                </div>
            </template>
        </Menu>
    </header>
</template>

<script lang="ts" setup>
    import { Menu } from 'primevue'
    import type { MenuItem } from 'primevue/menuitem'
    import { computed, ref } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRouter } from 'vue-router'

    import { useDarkMode } from '@/layouts/layout'
    import { useAppStore } from '@/stores/app'

    const { t }    = useI18n()
    const router   = useRouter()
    const appStore = useAppStore()

    const { isDark, toggleDark } = useDarkMode()

    const emit = defineEmits<{
        'toggle-mobile': []
    }>()

    const menu = ref<InstanceType<typeof Menu> | null>(null)

    const logout = () => {
        appStore.setLogout()
        router.push({ name: 'login' })
    }

    const menuItems = computed<MenuItem[]>(() => [
        { label: t('general.logout'), icon: 'pi pi-sign-out', command: logout },
    ])
</script>
